import { render, staticRenderFns } from "./Zone832.vue?vue&type=template&id=c5f281c0&scoped=true&"
import script from "./Zone832.vue?vue&type=script&lang=js&"
export * from "./Zone832.vue?vue&type=script&lang=js&"
import style0 from "./Zone832.vue?vue&type=style&index=0&id=c5f281c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f281c0",
  null
  
)

export default component.exports